export const Endpoints = {
  Industries: 'industries',
  Positions: 'positions',
  States: 'states',
  Cities: 'cities',
  Countries: 'countries',
  /** Retrieves all zip codes for a given city */
  Zips: 'zips',
  /** Search zip codes in the whole city/zip hierarchy */
  ZipCodes: 'zip-codes',
  Digs: 'digs',
  Inventories: 'inventories',
  Specialties: 'specialties',
  /** Retrieves all subspecialties for a given specialty */
  Subspecialties: 'specialties/:id/subspecialties',
  /** Search subspecialties in the industry/specialty/subspecialty hierarchy */
  SubspecialtiesSearch: 'subspecialties',
  PositionsSearch: 'positions/equivalents',
  SourceTypes: 'source-types',
  StartTimes: 'candidates/bluesheets/timetypes',
  CitiesSearch: 'cities/search',
  Search: 'search',
  ChannelPartner: 'channel-partner',
  Pil: 'pil',
  Statuses: 'statuses',
  PossibleEmployees: 'possible-employees',
  CountryCodes: 'phone-country-codes',
  PhoneTypes: 'phone-types',
  EmailVerdicts: 'emails/verdicts',
  Restrictions: 'contacts/restriction-requests',

  /**
   * Dashboard
   */
  DashboardBulkEmailSent: 'bulk-email-dashboard/total-bulk-sent',
  DashboardBulkEmailTrendSent: 'bulk-email-dashboard/trend-bulk-sent',
  DashboardBulkEmailStats: 'bulk-email-dashboard/total-bulk-stats',
  DashboardBulkEmailSentTable: 'bulk-email-dashboard/table-bulk-sent',

  /**
   * Placements
   */
  Placements: 'placements',
  PlacementSuggestions: 'placements/:id/suggest-update',
  PlacementInvoices: 'placements/:id/invoices',
  PlacementPayments: 'placements/:id/payments',
  PlacementPaymentsV2: '/erp-integrations/payments',
  PlacementStatuses: 'placements/statuses',
  PlacementSummary: 'placements/summary',
  PlacementLogs: 'placements/:id/logs',
  PlacementRequestMarkFallOff: 'placements/:id/requestFallOff',
  PlacementRequestRevertFallOff: 'placements/:id/requestRevertFallOff',
  PlacementMarkFallOff: 'placements/:id/markfallOff',
  PlacementRevertFallOff: 'placements/:id/revertFallOff',
  PlacementFallOffReasons: 'placements/fallOffReasons',
  PlacementRequestZip: 'placements/:id/compress-files',
  PlacementEstimate: 'placements/:id/estimate',
  PlacementApproveEstimate: 'placements/:id/approve-estimate',
  PlacementRecreateEstimate: 'placements/:id/mark-for-estimate-process',
  PlacementDeletePermanently: 'placements/:id',
  PaymentTerms: 'payment-terms',

  /**
   * Sendouts
   */
  Sendouts: 'sendouts',
  SendoutAttachments: 'sendouts/:id/attachments',
  SendoutBoardConfiguration: 'sendouts/board/config',
  SendoutDashBoard: 'sendouts/dashboard',
  SendoutDashboardLeadersDays: 'sendouts/dashboard/leaders/days',
  SendoutDashboardLeadersHeaders: 'sendouts/dashboard/leaders/headers',
  SendoutDashboardLeadersWeeks: 'sendouts/dashboard/leaders/weeks',
  SendoutDashboardMonths: 'sendouts/dashboard/months',
  SendoutDashBoardRecruiters: 'sendouts/dashboard/recruiters',
  SendoutDashBoardWeeks: 'sendouts/dashboard/weeks',
  SendoutDashboardWeeksByMonth: 'sendouts/dashboard/weeksByMonth',
  SendoutDashboardYears: 'sendouts/dashboard/years',
  SendoutDebriefingCalls: 'sendouts/interviews/:id/debriefing-calls',
  SendoutDuplicates: 'sendouts/duplicates',
  SendoutInterviewDetails: 'sendouts/interviews/:id',
  SendoutInterviews: 'sendouts/:id/interviews',
  SendoutPreparationCalls: 'sendouts/interviews/:id/preparation-calls',
  SendoutResendEmail: 'sendouts/:id/email/resend',
  SendoutsFiles: 'sendouts/:id/files',
  SendoutsFromChannelPartner: 'sendouts/from-channel-partners',
  SendoutsFromChannelPartnerSummary: 'sendouts/from-channel-partners/summary',
  SendoutsInterviewTypes: 'sendouts/interview-types',
  SendoutsLogs: 'sendouts/:id/logs',
  SendoutsNotes: 'sendouts/:id/notes',
  SendoutsStatus: 'sendouts/status-types',
  SendoutsSummary: 'sendouts/summary',
  SendoutsTemplate: 'sendouts/template',
  SendoutsTemplates: 'sendouts/templates',
  SendoutsTypes: 'sendouts/types',
  Sendover: 'sendovers',
  SendoverConvert: 'sendovers/convert/sendout/:id',
  SendoverConversion: 'sendovers/:id/conversion',
  SendoutReasons: 'sendouts/reasons',

  /**
   * @method GET - Returns data about company type change request
   * used to show more info to OPS team
   * @method PATCH - Receives company_type_id in body, used to update
   * comany type change when request is in progress (not yet checked by OPS)
   */

  PlacementBySendout: 'sendouts/:id/placements',
  Types: 'types',
  FilesForPlacement: 'sendouts/:id/file-types-to-create-placement',

  /**
   * Candidates
   */
  Candidates: 'candidates',
  CandidateAIMatchJobOrder: 'ai/candidates/:id/match/job-orders',
  CandidateAssignment: 'assign-candidate',
  CandidateClaimAccountability: 'candidates/:id/claim-accountability',
  CandidateCompany: 'candidates/:id/employer-company',
  CandidateCreateFromApplicant: 'talent-pool/applicants/:applicantId/draft',
  CandidateDataFromApplicant: 'talent-pool/applicants/:id/draft',
  CandidateDataFromResumeParser: 'resume-parser/:id',
  CandidateFiles: 'candidates/:id/files',
  CandidateMatchContact: '/candidates/:id/match/contacts',
  CandidateMatchJobOrder: '/candidates/:id/match/job-orders',
  CandidateParsedResumes: 'candidates/:id/parsed-resumes',
  CandidateRecentlyViewed: 'candidates/:id/recently-viewed',
  CandidateSearchProjects: 'candidates/:id/search-projects',
  CandidateSourceTypes: 'candidates/source-types',
  CandidateStatuses: 'candidates/statuses',
  CandidateSubStatuses: 'candidates/sub-statuses',
  CandidateSuggestedCompanies: 'candidates/:id/suggested-companies',
  CandidateTypes: 'candidates/bluesheets/candidatetypes',
  CandidatesResumeParser: 'candidates/resume-parsing',
  SearchCandidatesInTalentPool: 'talent-pool/applicants/search',

  /**
   * Company
   */
  Companies: 'companies',
  CompanyTypeReassure: 'companies/:id/type-reassure',
  CompanyTypeReassureOps: 'companies/:id/type-reassure-ops-verification',
  /**
   * @method GET - Returns data about company type change request
   * used to show more info to OPS team
   * @method PATCH - Receives company_type_id in body, used to update
   * comany type change when request is in progress (not yet checked by OPS)
   */
  CompanyTypeReassurePending: 'companies/:id/type-reassure/:referenceId',
  CompanyTypes: 'companies/types',
  CompanyRecentlyViewed: 'companies/:id/recently-viewed',
  CompanySearchProjects: 'companies/:id/search-projects',
  CompanyChangeLogs: 'change-logs',
  CompanyEmployees: 'companies/:id/employees',
  CompanyClaimAccountability: 'companies/:id/claim-accountability',
  CompanyPaymentStatus: 'erp-integrations/companies/:id/payment-status',
  CompanySales: 'erp-integrations/companies/:id/sales',

  /*
   * Job Orders
   */
  JobOrders: 'job-orders',
  JobOrderStatuses: 'job-orders/statuses',
  JobOrderTypes: 'job-orders/whiteSheets/jobordertypes',
  JobOrderRecentlyViewed: 'job-orders/:id/recently-viewed',
  JobOrderSourceTypes: 'job-orders/source-types',
  JobOrderAssigned: 'assign-job-order',
  JobOrderAvailableRecruitersForSendout: 'job-orders/:id/available-recruiters-for-sendout-creation',
  JobOrderSendouts: 'job-orders/:id/sendouts',
  JobOrderSendovers: 'job-orders/:id/sendovers',
  JobOrderParsedJobDescriptions: 'job-orders/:id/parsed-descriptions',
  JobOrderMatchCandidate: '/job-orders/:id/match/candidates',
  JobOrderAIMatchCandidate: 'ai/job-orders/:id/match/candidates',
  JobOrderAIMatchApplicants: 'ai/job-orders/:id/match/applicants',
  JobOrderAIMatchContacts: 'ai/job-orders/:id/match/contacts',
  JobOrderClaimAccountability: 'job-orders/:id/claim-accountability',
  JobOrderHiringAuthorities: 'job-orders/:id/hiring-authorities',

  /**
   * Contacts
   */
  Names: 'names',
  NameConvertedStatus: 'names/:id/conversion-status',
  NameRecentlyViewed: 'names/:id/recently-viewed',
  NameRoles: 'names/types',
  NameSearchProjects: 'names/:id/search-projects',
  NameStatus: 'names/grouped-statuses',
  NameSubStatuses: 'names/sub-statuses',
  NameSubStatusesByGroup: '/names/grouped-sub-statuses',
  NameTypes: 'names/grouped-types',
  NamesCompany: 'names/:id/employer-company',
  NamesSuggestedCompanies: 'names/:id/suggested-companies',
  SimpleStatuses: 'names/statuses?nameTypeId=:nameTypeId',

  /**
   * Search projects
   */
  SearchProjects: 'search-projects',
  SearchProjectsTypes: 'search-projects/types',
  SearchProjectQuickInfo: 'search-projects/:id/quick-info',
  /**
   * @method PUT - Updates sp name and privacy scope
   * @method DELETE - Deletes a SP logically by id param
   */
  SearchProjectDetail: 'search-projects/:id',
  SearchProjectRestore: 'search-projects/:id/restore',
  SearchProjectRestoreMany: 'search-projects/restore',
  /**
   * @method GET to preview sp items and data
   * @method DELETE to remove items from SP
   * @method PUT
   */
  SearchProjectsInventory: 'search-projects/:id/inventory',
  SearchProjectsAddPreview: 'search-projects/:id/preview',

  /**
   * Search projects collaborations
   */
  SearchProjectsAddCollaborator: 'search-projects/:id/collaboration',
  SearchProjectsRemoveCollaborator: 'search-projects/:id/collaboration/:collabIds',

  /**
   * Search projects activity log
   */
  SearchProjectHistoryEvents: 'search-projects/:id/history-events',

  /**
   * Search projects splits
   */
  SearchProjectSplit: 'search-projects/:id/inventory/split',

  /**
   * Search projects folders
   */

  /**
   * @method GET
   * @method POST
   */
  SearchProjectFolders: 'search-projects/folders',
  /**
   * @method GET
   * @method PUT
   */
  SearchProjectFolderById: 'search-projects/folders/:id',
  SearchProjectRestoreFolder: 'search-projects/folders/:id/restore',
  SearchProjectMoveToFolder: 'search-projects/folders/move-items',

  /**
   * Bulk Email
   */
  BulkEmails: 'bulk-emails',
  BulkEmailBodyImage: 'bulk-emails/image',
  BulkEmailById: 'bulk-emails/:id',
  BulkEmailGeneralCategories: 'bulk-emails/subcategories',
  BulkEmailMetrics: 'bulk-emails/:id/metrics',
  BulkEmailMetricsListing: 'bulk-emails/:id/metrics/listing',
  BulkEmailScope: 'bulk-emails/scopes',
  BulkEmailSignature: 'bulk-emails/signature',
  BulkEmailSmartTags: 'bulk-emails/smartags',
  BulkEmailsPreview: 'bulk-emails/preview/body',
  BulkUploadAttachment: 'bulk-emails/attachment',

  /**
   * Bulk Email Schedules
   */
  BulkEmailSchedules: 'bulk-emails/schedules',
  /**
   * @method GET
   * @method DELETE
   * @method PUT
   */
  BulkEmailScheduleById: 'bulk-emails/schedules/:id',

  /**
   * Bulk Email Scheduled - Send Now
   * @method POST
   */
  BulkEmailSendScheduledNow: 'bulk-emails/schedules/:id/send-now',
  /**
   * @method DELETE
   */
  BulkEmailDeschedule: 'bulk-emails/schedules/:id/deschedule',
  BulkEmailScheduleUpdateSendDate: 'bulk-emails/schedules/:id/send-date',

  /**
   * Bulk Email Drafts
   */

  BulkEmailsDrafts: 'bulk-emails/drafts',
  /**
   * @method PUT
   * @method DELETE
   */
  BulkEmailsDraftById: 'bulk-emails/drafts/:id',

  /**
   * Bulk Email Folders/Templates
   */
  BulkEmailsTemplates: 'bulk-emails/templates',
  BulkEmailsFolders: 'bulk-emails/folders',
  BulkEmailsFolderById: 'bulk-emails/folders/:id',
  BulkEmailsTemplatesSearch: 'bulk-emails/templates/search',
  BulkTemplateById: 'bulk-emails/templates/:id',
  BulkTemplateArchive: 'bulk-emails/templates/:id/archive',
  BulkTemplateRestore: 'bulk-emails/templates/:id/restore',
  BulkTemplateFolderArchive: 'bulk-emails/folders/:id/archive',
  BulkTemplateFolderRestore: 'bulk-emails/folders/:id/restore',

  /**
   * Bulk Email Opt In/Out
   */
  BulkEmailsOptOuts: 'bulk-emails/opt-outs',
  BulkEmailsOptOutsRemoveById: 'bulk-emails/opt-outs/:id',
  BulkEmailsOptOutReasons: 'bulk-emails/opt-outs/reasons',

  /**
   * Bulk Email Quota
   */
  BulkEmailOutlookQuota: 'bulk-emails/outlook-quota',

  /**
   * Bulk Email sequences
   */

  /**
   * @method GET
   */
  BulkSequencesTriggerDays: 'bulk-emails/sequences/days',
  /**
   * @method PUT
   */
  BulkSequencesEditStep: 'bulk-emails/:bulkId/sequences/:stepId',
  /**
   * @method POST
   */
  BulkSequencesAddSteps: 'bulk-emails/:id/sequences/entries',
  /**
   * @method POST
   */
  BulkSequencesCancelSequence: 'bulk-emails/:id/sequences/stop',
  /**
   * @method POST
   */
  BulkSequencesCancelSequenceStep: 'bulk-emails/:bulkId/sequences/entries/:stepId/stop',

  /**
   * Files
   */
  Files: 'files',
  FileCategories: 'files/types',
  FilesDelete: 'files/:id',
  Images: 'files/images',

  /**
   * Fee Agreements
   */
  FeeAgreement: 'fee-agreements',
  FeeAgreementOverridableUsers: 'fee-agreements/overridable-users',
  FeeAgreementUnmanaged: 'unmanaged-fee-agreements',
  FeeAgreementById: 'fee-agreements/:id',
  FeeAgreementsByCompany: 'fee-agreements/active-by-company',
  GuaranteeDays: 'fee-agreements/fee-agreement-guarantee-days-options',
  GuaranteeDaysGrouped: 'fee-agreements/fee-agreement-guarantee-days-options-by-payment-scheme',
  FeeAgreementValidationByCoach: ':id/coach-validation',
  FeeAgreementValidationByOperations: ':id/operations-validation',
  FeeAgreementUnmanagedValidationByOperations: ':id/operations-validation-for-unmanaged',

  FeeAgreementDeclinationByCoach: ':id/coach-declination',
  FeeAgreementDeclinationByOperations: ':id/operations-declination',
  FeeAgreementOperationsSendToSign: ':id/operations-send-to-sign',

  FeeAgreementRevalidationToCoach: ':id/send-to-coach-validation',
  FeeAgreementRevalidationToOperations: ':id/send-to-operations-validation',

  FeeAgreementStatuses: 'fee-agreement-statuses',
  FeeAgreementSendReminder: ':id/send-reminder',

  FeeAgreementCreateTemplateDraft: 'create-template-draft',
  FeeAgreementCreateSignatureRequestPreview: ':id/create-signature-request-preview',
  FeeAgreementVoidContract: 'void-contract',
  FeeAgreementCancelValidationRequest: 'cancel-validation-request',
  FeeAgreementUpdateEmails: ':id/emails',
  FeeAgreementTemplate: 'template',
  FeeAgreementTemplates: 'templates',
  FeeAgreementRestoreExpired: 'restore-expired',
  FeeAgreementSwitchProvider: 'switch-to-backup-service',
  FeeAgreementTempFile: 'fee-agreements/temporary-file',
  FeeAgreementPaymentCombinations: 'fee-agreements/payment-combinations',
  FeeAgreementPaymentSchemes: 'fee-agreements/payment-schemes',

  FeeAgreementDashboard: 'fee-agreements/dashboard/board',
  FeeAgreementDashboardWeeks: 'fee-agreements/dashboard/weeks',
  FeeAgreementDashboardYears: 'fee-agreements/dashboard/years',
  FeeAgreementDashboardRecruiters: 'fee-agreements/dashboard/recruiters',

  Notes: 'notes',
  Users: 'users',
  UsersRefreshToken: 'users/token/refresh',
  UserRoles: 'users/:id/roles',
  UserPhones: 'texting/v2/phone-numbers',
  Roster: 'roster',
  Offices: 'users/roster/offices',
  Departments: 'departments',
  Recruiters: 'recruiters',
  RecruitersByCoach: 'recruiters/byCoach',
  UserBasics: 'users/:id/basicInfo',
  Roles: 'roles',
  WorkTypes: 'workTypeOptions',
  Dashboard: 'dashboard',
  AssignmentHistory: 'getAssignmentHistory',
  Reassign: 'reassign',
  AdditionalRecruiters: 'additional-recruiters',
  NotificationHistory: 'notifications/get-notification-history',
  NotificationRegistration: 'notifications/add-registration-token',
  NotificationMarkAsRead: 'notifications/mark-notification-as-read',
  Phone: 'phone',
  Managers: 'users/managers',
  ReferenceReleases: 'reference-releases',
  ReferenceReleaseTemplate: 'reference-releases/template',
  Unlink: 'unlink',
  UserStatuses: 'statuses',
  UserTimeZones: 'users/timezones',

  /**
   * Activities
   */
  Activities: 'activityLogs',
  ActivitiesCallDuration: 'call-durations',
  ActivitiesCallTypes: 'call-types',
  ActivitiesCallsDirection: 'call-directions',
  ActivityLogs: 'activity-logs',
  ActivityOutcomes: 'activity-logs/outcomes',
  ActivityTimeFilters: 'time-filters',
  ActivityTypes: 'activityLogTypes',

  /**
   * Hiring Authorities
   */
  AvailableHiringAuthorities: 'available-hiring-authorities',
  HiringAuthorities: 'hiring-authorities',
  HiringAuthoritiesStatuses: 'hiring-authorities/statuses',
  HiringAuthorityRecentlyViewed: 'hiring-authorities/:id/recently-viewed',
  HiringAuthoritySearchProjects: 'hiring-authorities/:id/search-projects',
  HiringAuthoritySubStatuses: 'hiring-authorities/sub-statuses',

  /**
   * Home
   */
  HomeConfig: 'home/config',
  HomeConfigTabs: 'home/config-tabs',

  /**
   * Entity Types
   */
  EntityTypes: '/entity-types',

  /**
   * ----------------------------
   *          VERSION 2
   * ----------------------------
   */

  /**
   * Dashboard
   */
  DashboardBulkEmail: 'bulk-email-dashboard/report',
  DashboardBulkEmailDownloadCSV: 'bulk-email-dashboard/table-bulk-sent-spreadsheet',

  /**
   * ----------------------------
   *          VERSION 2
   * ----------------------------
   */
  ToolsUsageReportData: 'tools-usage-report/data',
  ToolsUsageReportWeeks: 'tools-usage-report/weeks',
  ToolsUsageReportRecruiters: 'tools-usage-report/recruiters',
  ToolsUsageReportDownload: 'tools-usage-report/download-report',

  ToolsUsageReportDataV2: 'tools-usage/tools-usage-report/v2/regional-coaches/report',
  ToolsUsageReportRecruitersV2: 'tools-usage/tools-usage-report/v2/recruiters',
  ToolsUsageReportDownloadV2: 'tools-usage/tools-usage-report/v2/download-data-by-week',

  /**
   * Associated Companies
   */

  /**
   * @method GET
   */
  PossibleParentCompany: 'companies/possible-parent-companies-for-new-company',
  PossibleSiblingCompanies: 'companies/possible-sister-companies-for-new-company',
  PossibleChildCompanies: 'companies/possible-child-companies-for-new-company',
  PossibleParentExistingCompany: 'companies/:id/possible-parent-companies',
  PossibleChildOrSiblingExistingCompany: 'companies/:id/possible-child-or-sister-companies',
  AssociatedCompanies: 'associated-companies',
  AssociatedCompaniesTree: 'associated-companies-tree',

  /**
   * @method PUT
   * @method DELETE
   */
  ParentCompany: 'companies/:id/parent-company',
  SisterCompanies: 'companies/:id/sister-companies',
  ChildCompanies: 'companies/:id/child-companies',

  /**
   * ----------------------------
   *          VERSION 2
   * ----------------------------
   */

  /**
   * ----------------------------
   *          API AWS
   * ----------------------------
   */
  /**
   * @method GET
   */
  ReferenceCheckByCandidate: 'reference-checks/candidate',
  ReferenceCheck: 'reference-checks/reference',
  ReferenceCheckDownload: '/reference-checks/:referenceId/download',

  /**
   * RC EVENT FILTER
   */
  RcEventFilter: 'rc-filter-events/send',

  /**
   * ----------------------------
   *          SECONDARY API AWS
   * ----------------------------
   */
  JSONSchema: `forms-builder/schema?key=:schemaName`,
  /**
   * ----------------------------
   *          DATA SHEET
   * ----------------------------
   */
  DataSheetByJobOrderId: 'dynamic-data-sheet/job-order-data-sheet/by-job-order/:id',
  DataSheetSaveCompleted: 'dynamic-data-sheet/job-order-data-sheet/save',
  DataSheetSaveDraft: 'dynamic-data-sheet/job-order-data-sheet/draft',
  DataSheetById: 'dynamic-data-sheet/job-order-data-sheet/:id',
  /**
   * ----------------------------
   *          CANDIDATE DATA SHEET
   * ----------------------------
   */
  CandidateDataSheetByCandidateId: 'dynamic-data-sheet/candidate-data-sheet/by-candidate/:id',
  CandidateDataSheetSave: 'dynamic-data-sheet/candidate-data-sheet/save',
  CandidateDataSheetSaveDraft: 'dynamic-data-sheet/candidate-data-sheet/draft',
  CandidateDataSheetById: 'dynamic-data-sheet/candidate-data-sheet/:id',
  /**
   * ----------------------------
   *          CONTACT DATA SHEET
   * ----------------------------
   */
  ContactDataSheetById: 'dynamic-data-sheet/contact-data-sheets/:id',

  /**
   * Collections
   */
  Collections: '/erp-integrations/accounts-receivable/v2',
  CollectionsInvoices: '/erp-integrations/accounts-receivable/invoices',
  CollectionsInvoiceTypes: '/erp-integrations/accounts-receivable/invoices/types',
  CollectionsTeams: '/erp-integrations/accounts-receivable/teams',
  CollectionsTeamsOnInvoices: '/erp-integrations/accounts-receivable/teams-on-invoice',

  /**
   * Urgency Verification
   */
  UrgencyVerificationCandidates: '/urgency-verification/candidates/:id/verifications',
  UrgencyVerificationJobOrders: '/urgency-verification/job-orders/:id/verifications',

  /**
   * Keyword Tags
   */
  KeywordTags: '/keyword-tags',
  /**
   * Talent Pool
   */
  TalentPoolSkills: 'talent-pool/catalogs/skills',
  TalentPoolCities: 'talent-pool/catalogs/cities',
  TalentPoolCountries: 'talent-pool/catalogs/countries',
  TalentPoolStates: 'talent-pool/catalogs/states',
  TalentPoolSchoolTypes: 'talent-pool/catalogs/schoolTypes'
};
